import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import {
  selectDeviceListColumnVisibility,
} from '../../../../../redux/slices/filteredDeviceListSlice/filteredDeviceListSlice';
import styles from './DeviceListTableRow.module.css';
import envConfig from '../../../../../envConfig';
import HasRolePrivileges from '../../../../highorder/HasRolePrivileges';
import { RaaRoles } from '../../../../../utility/SecurityRules';

/* istanbul ignore next */
function DeviceListTableRow({
  device,
  index,
  hoveredIndex,
  setHoveredIndex,
  isSelected,
  handleSetSelected,
}) {
  const deviceListColumnVisibility = useSelector(selectDeviceListColumnVisibility);
  const history = useHistory();

  const getHoveredStyle = () => (hoveredIndex === index ? `row-hovered avt-table-row ${styles.tableRowSuspended}` : `avt-table-row ${styles.tableRowSuspended}`);

  return (
    <tr
      className={getHoveredStyle()}
      onMouseEnter={() => setHoveredIndex(index)}
      onMouseLeave={() => setHoveredIndex(null)}
      onClick={() => history.push(`${envConfig.raaUrl}/devices/${device.id}`)}
    >

      <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
        <td id="device-checkbox-col" style={{ paddingLeft: '0.75rem', paddingRight: '1.0rem' }}>
          <span>
            <input
              type="checkbox"
              id={`${device.deviceName}-checkbox`}
              name={device.deviceName}
              checked={isSelected}
              onChange={() => handleSetSelected()}
            />
          </span>
        </td>
      </HasRolePrivileges>

      {deviceListColumnVisibility['Push Status'] && (
        <td className="ellipsis width-10"><span /></td>
      )}
      {deviceListColumnVisibility['Device Name'] && (
        <td className="ellipsis text-muted width-10">
          <span>
            {device.deviceName}
            {' '}
            <FontAwesomeIcon
              icon={faQuestionCircle}
              className="text-muted ml-2"
              style={{ cursor: 'pointer' }}
              title="Device Suspended! Upgrade your account to access data."
            />
          </span>
        </td>
      )}
      {deviceListColumnVisibility.Tags && (
        <td className="ellipsis width-10" />)}

      {deviceListColumnVisibility.Model && (
        <td className="text-muted ellipsis width-15">
          <span>
            {device.roomAlertTypeDisplayString}
          </span>
        </td>
      )}

      {deviceListColumnVisibility['MAC Address'] && (
      <td className="text-muted ellipsis width-15">
        <span>
          {device.macAddress}
        </span>
      </td>
      )}
      {deviceListColumnVisibility['Last Message'] && (
      <td className="ellipsis width-15" />
      )}

      {deviceListColumnVisibility['Room Alert Link'] && (
        <td className="ellipsis width-15" />
      )}

      {deviceListColumnVisibility.Firmware && (
        <td className="ellipsis width-10" />
      )}
    </tr>
  );
}

DeviceListTableRow.propTypes = {
  device: PropTypes.shape({
    id: PropTypes.string.isRequired,
    deviceName: PropTypes.string.isRequired,
    roomAlertTypeDisplayString: PropTypes.string.isRequired,
    macAddress: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  hoveredIndex: PropTypes.number.isRequired,
  setHoveredIndex: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  handleSetSelected: PropTypes.bool.isRequired,
};

export default DeviceListTableRow;
